/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded School.
 * @export
 */
export const ICON_SCHOOL = (
  <svg fill="#000000" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M2.06376 8.11625L10.4938 3.51625C11.0938 3.19625 11.8138 3.19625 12.4138 3.51625L21.9338 8.70624C22.2538 8.88624 22.4538 9.21625 22.4538 9.58625V15.9962C22.4538 16.5462 22.0038 16.9962 21.4538 16.9962C20.9038 16.9962 20.4538 16.5462 20.4538 15.9962V10.0862L12.4138 14.4762C11.8138 14.8062 11.0938 14.8062 10.4938 14.4762L2.06376 9.87625C1.37376 9.49624 1.37376 8.49625 2.06376 8.11625ZM4.45376 15.9862V13.1762L10.4938 16.4762C11.0938 16.8062 11.8138 16.8062 12.4138 16.4762L18.4538 13.1762V15.9862C18.4538 16.7162 18.0538 17.3962 17.4138 17.7462L12.4138 20.4762C11.8138 20.8062 11.0938 20.8062 10.4938 20.4762L5.49376 17.7462C4.85376 17.3962 4.45376 16.7162 4.45376 15.9862Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
